import { IIconProps } from "@/models";
import { SvgIcon } from "@mui/material";

const RadioDefaultIcon = ({ sx, ...otherProps }: IIconProps) => {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      sx={{ fontSize: "inherit", ...sx }}
      {...otherProps}
    >
      <mask id="path-1-inside-1_3318_25792" fill="white">
        <path d="M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" />
      </mask>
      <path
        d="M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z"
        fill="white"
      />
      <path
        d="M12 22.5C6.20101 22.5 1.5 17.799 1.5 12H-1.5C-1.5 19.4558 4.54416 25.5 12 25.5V22.5ZM22.5 12C22.5 17.799 17.799 22.5 12 22.5V25.5C19.4558 25.5 25.5 19.4558 25.5 12H22.5ZM12 1.5C17.799 1.5 22.5 6.20101 22.5 12H25.5C25.5 4.54416 19.4558 -1.5 12 -1.5V1.5ZM12 -1.5C4.54416 -1.5 -1.5 4.54416 -1.5 12H1.5C1.5 6.20101 6.20101 1.5 12 1.5V-1.5Z"
        fill="#DBDBDB"
        mask="url(#path-1-inside-1_3318_25792)"
      />
    </SvgIcon>
  );
};

export default RadioDefaultIcon;
